"use client";

import { cn } from "@/lib/utils";
import { Toaster } from "@/components/ui/sonner";
import { ThemeProvider } from "@/lib/theme-context";
import { Analytics } from "@vercel/analytics/react";
import { PlanProvider } from "./admin/_hooks/use-plan";
import { TooltipProvider } from "@/components/ui/tooltip";
import { useBetterEmailAuth } from "@/providers/better-email-auth-provider";
import { ImpersonationBanner } from "@/components/layouts/impersonation-banner";
import { SidebarProvider } from "@/components/ui/sidebar";

export default function ClientShell({ children }: { children: React.ReactNode }) {
  const { isAuthenticated, isLoading } = useBetterEmailAuth();

  if (isLoading) return null;

  return (
    <>
      <ThemeProvider defaultTheme="light" storageKey="journey-ui-theme">
        <TooltipProvider>
          <PlanProvider>
            <div className="flex flex-col min-h-screen gap-0 w-full">
              {isAuthenticated && <ImpersonationBanner />}
              <main className={cn("flex flex-col")}>{children}</main>
            </div>
          </PlanProvider>
        </TooltipProvider>
      </ThemeProvider>
      <Analytics />
      <Toaster richColors />
    </>
  );
}
